import { useState, useEffect } from 'react'
import * as XLSX from 'xlsx'
import { api } from '../services/api'
import { getCurrentUser } from '../services/auth'

const ESTADOS_CIVIS = ['solteiro', 'casado', 'divorciado', 'viúvo', 'separado', 'união estável']

const CAMPOS = [
  { key: 'nome',            label: 'Nome completo', col: 2 },
  { key: 'cpf',             label: 'CPF',           col: 1 },
  { key: 'rg',              label: 'RG',            col: 1 },
  { key: 'cnh',             label: 'CNH',           col: 1 },
  { key: 'data_nascimento', label: 'Nascimento',    col: 1, type: 'date' },
  { key: 'estado_civil',    label: 'Estado Civil',  col: 1 },
  { key: 'profissao',       label: 'Profissão',     col: 1 },
  { key: 'telefone',        label: 'Telefone',      col: 1 },
  { key: 'email',           label: 'E-mail',        col: 2, type: 'email' },
  { key: 'endereco',        label: 'Endereço',      col: 2 },
  { key: 'numero',          label: 'Número',        col: 1 },
  { key: 'complemento',     label: 'Complemento',   col: 1 },
  { key: 'bairro',          label: 'Bairro',        col: 1 },
  { key: 'cep',             label: 'CEP',           col: 1 },
  { key: 'cidade',               label: 'Cidade',                col: 1 },
  { key: 'estado',               label: 'Estado (UF)',           col: 1 },
  { key: 'referencia1_nome',     label: 'Referência 1 — Nome',   col: 1, section: 'refs' },
  { key: 'referencia1_telefone', label: 'Referência 1 — Fone',   col: 1, section: 'refs' },
  { key: 'referencia2_nome',     label: 'Referência 2 — Nome',   col: 1, section: 'refs' },
  { key: 'referencia2_telefone', label: 'Referência 2 — Fone',   col: 1, section: 'refs' },
  { key: 'referencia3_nome',     label: 'Referência 3 — Nome',   col: 1, section: 'refs' },
  { key: 'referencia3_telefone', label: 'Referência 3 — Fone',   col: 1, section: 'refs' },
]

const COLUNAS_EXCEL = [
  { key: 'nome',            header: 'Nome' },
  { key: 'cpf',             header: 'CPF' },
  { key: 'rg',              header: 'RG' },
  { key: 'cnh',             header: 'CNH' },
  { key: 'data_nascimento', header: 'Nascimento' },
  { key: 'estado_civil',    header: 'Estado Civil' },
  { key: 'profissao',       header: 'Profissão' },
  { key: 'telefone',        header: 'Telefone' },
  { key: 'email',           header: 'E-mail' },
  { key: 'endereco',        header: 'Endereço' },
  { key: 'numero',          header: 'Número' },
  { key: 'complemento',     header: 'Complemento' },
  { key: 'bairro',          header: 'Bairro' },
  { key: 'cep',             header: 'CEP' },
  { key: 'cidade',               header: 'Cidade' },
  { key: 'estado',               header: 'UF' },
  { key: 'referencia1_nome',     header: 'Ref.1 Nome' },
  { key: 'referencia1_telefone', header: 'Ref.1 Fone' },
  { key: 'referencia2_nome',     header: 'Ref.2 Nome' },
  { key: 'referencia2_telefone', header: 'Ref.2 Fone' },
  { key: 'referencia3_nome',     header: 'Ref.3 Nome' },
  { key: 'referencia3_telefone', header: 'Ref.3 Fone' },
]

const clienteVazio = {
  nome: '', cpf: '', rg: '', cnh: '', data_nascimento: '',
  estado_civil: 'solteiro', profissao: '',
  endereco: '', numero: '', complemento: '', bairro: '',
  cidade: 'Curitiba', estado: 'PR', cep: '',
  telefone: '', email: '',
  referencia1_nome: '', referencia1_telefone: '',
  referencia2_nome: '', referencia2_telefone: '',
  referencia3_nome: '', referencia3_telefone: '',
}

function exportarExcel(clientes) {
  const rows = clientes.map(c =>
    Object.fromEntries(COLUNAS_EXCEL.map(({ key, header }) => [header, c[key] || '']))
  )
  const ws = XLSX.utils.json_to_sheet(rows)
  const colWidths = COLUNAS_EXCEL.map(({ header }) => ({
    wch: Math.max(header.length, ...clientes.map(c => String(c[COLUNAS_EXCEL.find(col => col.header === header).key] || '').length)) + 2
  }))
  ws['!cols'] = colWidths
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, 'Clientes')
  XLSX.writeFile(wb, `clientes_zf_${new Date().toISOString().slice(0, 10)}.xlsx`)
}

function FormCliente({ titulo, dados, onChange, onSubmit, onCancelar, salvando, erro, submitLabel }) {
  const set = (key, val) => onChange({ ...dados, [key]: val })

  return (
    <div style={{
      background: 'var(--card-bg)', borderRadius: '22px', border: '1px solid var(--card-border)',
      padding: '2rem', marginBottom: '1.5rem',
      boxShadow: '0 2px 16px rgba(0,0,0,0.12)',
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
        <h2 style={{ margin: 0, border: 'none', padding: 0 }}>{titulo}</h2>
        {onCancelar && <button onClick={onCancelar} style={{ padding: '6px 14px', fontSize: '12px' }}>Cancelar</button>}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
        {CAMPOS.filter(c => !c.section).map(({ key, label, col, type }) => (
          <div key={key} className="field" style={{ gridColumn: col === 2 ? 'span 2' : 'span 1' }}>
            <label>{label}</label>
            {key === 'estado_civil' ? (
              <select value={dados[key] || 'solteiro'} onChange={e => set(key, e.target.value)}>
                {ESTADOS_CIVIS.map(e => <option key={e} value={e}>{e}</option>)}
              </select>
            ) : (
              <input type={type || 'text'} value={dados[key] || ''} onChange={e => set(key, e.target.value)} />
            )}
          </div>
        ))}
      </div>

      <div style={{ borderTop: '1px solid var(--section-border)', paddingTop: '1rem', marginTop: '1rem' }}>
        <div style={{ fontSize: '11px', letterSpacing: '0.10em', textTransform: 'uppercase', color: 'var(--text-secondary)', marginBottom: '0.75rem' }}>
          Contatos de Referência
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
          {CAMPOS.filter(c => c.section === 'refs').map(({ key, label }) => (
            <div key={key} className="field">
              <label>{label}</label>
              <input type="text" value={dados[key] || ''} onChange={e => set(key, e.target.value)} />
            </div>
          ))}
        </div>
      </div>

      {erro && <div className="badge-err" style={{ marginTop: '1rem' }}>{erro}</div>}

      <button
        className="btn-gold"
        style={{ marginTop: '1.5rem' }}
        onClick={onSubmit}
        disabled={salvando}
      >
        {salvando ? 'SALVANDO...' : submitLabel}
      </button>
    </div>
  )
}

function ModalEditar({ cliente, onSalvar, onFechar }) {
  const [form, setForm] = useState({ ...cliente })
  const [salvando, setSalvando] = useState(false)
  const [erro, setErro] = useState('')

  const salvar = async () => {
    setSalvando(true)
    setErro('')
    try {
      const atualizado = await api.clientes.atualizar(cliente.id, form)
      onSalvar(atualizado)
    } catch (e) {
      setErro(e.message)
    } finally {
      setSalvando(false)
    }
  }

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 1000, padding: '1rem',
    }}>
      <div style={{
        background: 'var(--card-bg)', borderRadius: '22px', border: '1px solid var(--card-border)',
        padding: '2rem', width: '100%', maxWidth: '680px',
        maxHeight: '90vh', overflowY: 'auto',
        boxShadow: '0 8px 40px rgba(0,0,0,0.35)',
      }}>
        <FormCliente
          titulo="Editar Cliente"
          dados={form}
          onChange={setForm}
          onSubmit={salvar}
          onCancelar={onFechar}
          salvando={salvando}
          erro={erro}
          submitLabel="SALVAR ALTERAÇÕES"
        />
      </div>
    </div>
  )
}

function ModalConfirmarExclusao({ cliente, onConfirmar, onCancelar }) {
  const [excluindo, setExcluindo] = useState(false)
  const [erro, setErro] = useState('')

  const confirmar = async () => {
    setExcluindo(true)
    setErro('')
    try {
      await api.clientes.excluir(cliente.id, 'Exclusão manual pelo master')
      onConfirmar(cliente.id)
    } catch (e) {
      setErro(e.message)
      setExcluindo(false)
    }
  }

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 1100, padding: '1rem',
    }}>
      <div style={{
        background: 'var(--card-bg)', borderRadius: '18px', border: '1px solid var(--card-border)',
        padding: '2rem', width: '100%', maxWidth: '420px',
        boxShadow: '0 8px 40px rgba(0,0,0,0.4)',
      }}>
        <h2 style={{ margin: '0 0 1rem', border: 'none', padding: 0 }}>Desativar cliente</h2>
        <p style={{ fontSize: '14px', color: 'var(--text-secondary)', marginBottom: '1.5rem' }}>
          O cliente <strong>{cliente.nome}</strong> (CPF: {cliente.cpf}) será desativado e não aparecerá mais nas listagens. Esta ação pode ser revertida pelo banco de dados.
        </p>
        {erro && <div className="badge-err" style={{ marginBottom: '1rem' }}>{erro}</div>}
        <div style={{ display: 'flex', gap: '0.75rem' }}>
          <button onClick={onCancelar} style={{ flex: 1 }}>Cancelar</button>
          <button
            onClick={confirmar}
            disabled={excluindo}
            style={{
              flex: 1,
              background: '#c0392b',
              border: '1px solid #c0392b',
              color: '#fff',
              borderRadius: '10px',
              fontWeight: 'bold',
              fontSize: '13px',
              padding: '10px',
              cursor: excluindo ? 'not-allowed' : 'pointer',
              opacity: excluindo ? 0.7 : 1,
            }}
          >
            {excluindo ? 'DESATIVANDO...' : 'CONFIRMAR DESATIVAÇÃO'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default function CadastrarCliente() {
  const user = getCurrentUser()
  const isMaster = user?.role === 'master'

  const [clientes, setClientes]         = useState([])
  const [busca, setBusca]               = useState('')
  const [editando, setEditando]         = useState(null)
  const [excluindo, setExcluindo]       = useState(null)
  const [mostraCadastro, setMostraCadastro] = useState(false)
  const [novoCliente, setNovoCliente]   = useState(clienteVazio)
  const [cadastrando, setCadastrando]   = useState(false)
  const [erroCadastro, setErroCadastro] = useState('')
  const [sucesso, setSucesso]           = useState('')

  useEffect(() => { api.clientes.listar().then(setClientes).catch(() => {}) }, [])

  const filtrados = clientes.filter(c =>
    c.nome.toLowerCase().includes(busca.toLowerCase()) || c.cpf.includes(busca)
  )

  const aoSalvar = (atualizado) => {
    setClientes(cs => cs.map(c => c.id === atualizado.id ? atualizado : c))
    setEditando(null)
    setSucesso(`Dados de ${atualizado.nome} atualizados com sucesso.`)
    setTimeout(() => setSucesso(''), 4000)
  }

  const aoExcluir = (id) => {
    setClientes(cs => cs.filter(c => c.id !== id))
    setExcluindo(null)
    setSucesso('Cliente desativado com sucesso.')
    setTimeout(() => setSucesso(''), 4000)
  }

  const abrirEdicao = async (cliente) => {
    try {
      const completo = await api.clientes.buscar(cliente.id)
      setEditando(completo)
    } catch {
      setEditando(cliente)
    }
  }

  const handleCadastrar = async () => {
    setErroCadastro('')
    if (!novoCliente.nome || !novoCliente.cpf || !novoCliente.rg || !novoCliente.cnh ||
        !novoCliente.profissao || !novoCliente.endereco || !novoCliente.numero ||
        !novoCliente.bairro || !novoCliente.cep || !novoCliente.telefone)
      return setErroCadastro('Preencha todos os campos obrigatórios.')
    if (!novoCliente.referencia1_nome || !novoCliente.referencia1_telefone ||
        !novoCliente.referencia2_nome || !novoCliente.referencia2_telefone ||
        !novoCliente.referencia3_nome || !novoCliente.referencia3_telefone)
      return setErroCadastro('Informe os 3 contatos de referência (nome e telefone).')

    setCadastrando(true)
    try {
      const novo = await api.clientes.cadastrar(novoCliente)
      setClientes(prev => [novo, ...prev])
      setNovoCliente(clienteVazio)
      setMostraCadastro(false)
      setSucesso(`Cliente ${novo.nome} cadastrado com sucesso.`)
      setTimeout(() => setSucesso(''), 4000)
    } catch (e) {
      setErroCadastro(e.message)
    } finally {
      setCadastrando(false)
    }
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
        <h1 style={{ fontSize: '20px', fontWeight: 'normal', letterSpacing: '0.06em', margin: 0, color: 'var(--text-primary)' }}>CLIENTES</h1>
        <div style={{ display: 'flex', gap: '0.75rem' }}>
          <button
            onClick={() => { setMostraCadastro(v => !v); setErroCadastro('') }}
            style={{ fontSize: '12px', padding: '7px 16px', background: mostraCadastro ? 'var(--active-bg)' : undefined, borderColor: mostraCadastro ? '#C9A84C' : undefined }}
          >
            {mostraCadastro ? 'Cancelar' : '+ Novo Cliente'}
          </button>
          <button
            onClick={() => exportarExcel(clientes)}
            disabled={clientes.length === 0}
            className="btn-green"
            style={{ fontSize: '12px', padding: '7px 16px' }}
          >
            Exportar Excel
          </button>
        </div>
      </div>

      {sucesso && <div className="badge-ok" style={{ marginBottom: '1rem' }}>{sucesso}</div>}

      {mostraCadastro && (
        <FormCliente
          titulo="Novo Cliente"
          dados={novoCliente}
          onChange={setNovoCliente}
          onSubmit={handleCadastrar}
          onCancelar={() => { setMostraCadastro(false); setNovoCliente(clienteVazio); setErroCadastro('') }}
          salvando={cadastrando}
          erro={erroCadastro}
          submitLabel="CADASTRAR CLIENTE"
        />
      )}

      <div className="card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
          <h2 style={{ margin: 0, border: 'none', padding: 0 }}>Clientes cadastrados ({clientes.length})</h2>
          <input type="text" placeholder="Buscar por nome ou CPF..." value={busca}
            onChange={e => setBusca(e.target.value)} style={{ width: '260px' }} />
        </div>

        {filtrados.length === 0 ? (
          <p style={{ fontSize: '14px', color: 'var(--text-secondary)', margin: 0 }}>
            {busca ? 'Nenhum cliente encontrado.' : 'Nenhum cliente cadastrado.'}
          </p>
        ) : (
          <table>
            <thead>
              <tr>{['Nome', 'CPF', 'Telefone', 'Cidade/UF', ''].map(h => <th key={h}>{h}</th>)}</tr>
            </thead>
            <tbody>
              {filtrados.map(c => (
                <tr key={c.id}>
                  <td style={{ fontWeight: 'bold' }}>{c.nome}</td>
                  <td>{c.cpf}</td>
                  <td>{c.telefone}</td>
                  <td>{c.cidade || '—'}{c.cidade && c.estado ? `/${c.estado}` : (c.estado || '')}</td>
                  <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                    <button
                      onClick={() => abrirEdicao(c)}
                      className="btn-amber"
                      style={{ fontSize: '12px', padding: '5px 14px', marginRight: isMaster ? '6px' : 0 }}
                    >
                      Editar
                    </button>
                    {isMaster && (
                      <button
                        onClick={() => setExcluindo(c)}
                        style={{
                          fontSize: '12px', padding: '5px 14px',
                          background: 'transparent', border: '1px solid #c0392b',
                          color: '#c0392b', borderRadius: '8px', cursor: 'pointer',
                        }}
                      >
                        Excluir
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {editando && (
        <ModalEditar
          cliente={editando}
          onSalvar={aoSalvar}
          onFechar={() => setEditando(null)}
        />
      )}

      {excluindo && (
        <ModalConfirmarExclusao
          cliente={excluindo}
          onConfirmar={aoExcluir}
          onCancelar={() => setExcluindo(null)}
        />
      )}
    </div>
  )
}
